export function truncateAddress(address: string, startChars = 5, endChars = 4) {
  if (typeof address !== 'string') {
    throw new Error('Address must be a string');
  }
  if (address.length <= startChars + endChars) {
    return address; // Return full address if it's already short
  }
  const start = address.slice(0, startChars);
  const end = address.slice(-endChars);
  return `${start}...${end}`;
}
